import { render, staticRenderFns } from "./SinusoidalFunction.component.vue?vue&type=template&id=c4790ee2&scoped=true"
import script from "./SinusoidalFunction.component.ts?vue&type=script&lang=js&external"
export * from "./SinusoidalFunction.component.ts?vue&type=script&lang=js&external"
import style0 from "./SinusoidalFunction.component.vue?vue&type=style&index=0&id=c4790ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4790ee2",
  null
  
)

export default component.exports